export type ISampleQuestions = {
  id: number;
  title: string;
};

export const SAMPLE_QUESTIONS: Record<number, ISampleQuestions[]> = {
  302: [
    { id: 1, title: 'نمونه سوالات امتحانی ریاضی و آمار دهم انسانی - سری 3' },
    { id: 2, title: 'نمونه سوالات امتحانی ریاضی و آمار دهم انسانی - سری 4' },
    { id: 3, title: 'نمونه سوالات امتحانی ریاضی و آمار دهم انسانی - سری 5' },
    { id: 4, title: 'نمونه سوالات امتحانی ریاضی و آمار دهم انسانی - سری 6' },
    { id: 5, title: 'نمونه سوالات شبه نهایی ریاضی و آمار دهم انسانی - سری 2' },
    { id: 6, title: 'نمونه سوالات نهایی ریاضی و آمار دهم انسانی - سری 1' },
  ],
  303: [
    { id: 1, title: 'امتحان نهایی ریاضی  دهم خرداد 1403' },
    { id: 2, title: 'ریاضی دهم ریاضی و تجربی نوبت دوم - سری 1' },
    { id: 3, title: 'ریاضی دهم ریاضی و تجربی نوبت دوم - سری 2' },
    { id: 4, title: 'ریاضی دهم ریاضی و تجربی نوبت دوم - سری 3' },
    { id: 5, title: 'ریاضی دهم ریاضی و تجربی نوبت دوم - سری4' },
    { id: 6, title: 'شبه نهایی ریاضی دهم ریاضی و تجربی نوبت دوم  ادریبهشت 1403' },
  ],
  304: [
    { id: 1, title: 'امتحان نهایی ریاضی  دهم خرداد 1403' },
    { id: 2, title: 'ریاضی دهم ریاضی و تجربی نوبت دوم - سری 1' },
    { id: 3, title: 'ریاضی دهم ریاضی و تجربی نوبت دوم - سری 2' },
    { id: 4, title: 'ریاضی دهم ریاضی و تجربی نوبت دوم - سری 3' },
    { id: 5, title: 'ریاضی دهم ریاضی و تجربی نوبت دوم - سری4' },
    { id: 6, title: 'شبه نهایی ریاضی دهم ریاضی و تجربی نوبت دوم  ادریبهشت 1403' },
  ],
  305: [
    { id: 1, title: 'نهایی هندسه 1 رشته ریاضی خرداد 1403' },
    { id: 2, title: 'هندسه 1 رشته ریاضی خرداد 1400' },
    { id: 3, title: 'هندسه 1 رشته ریاضی خرداد 1401' },
    { id: 4, title: 'هندسه 1 ریاضی خرداد 1401' },
    { id: 5, title: 'هندسه 1رشته ریاضی نوبت دوم' },
    { id: 6, title: 'هندسه 1ریاضی نوبت دوم' },
  ],
  306: [
    { id: 1, title: 'امتحان نهایی شیمی 1  خرداد 1403' },
    { id: 2, title: 'شبه نهایی شیمی 1 اردیبهشت 1403' },
    { id: 3, title: 'شیمی دهم نوبت دوم - سری 1' },
    { id: 4, title: 'شیمی دهم نوبت دوم - سری 2' },
    { id: 5, title: 'شیمی دهم نوبت دوم - سری 3' },
    { id: 6, title: 'شیمی دهم نوبت دوم - سری 4' },
    { id: 7, title: 'شیمی دهم نوبت دوم - سری 5' },
  ],
  307: [
    { id: 1, title: 'امتحان نهایی شیمی 1  خرداد 1403' },
    { id: 2, title: 'شبه نهایی شیمی 1 اردیبهشت 1403' },
    { id: 3, title: 'شیمی دهم نوبت دوم - سری 1' },
    { id: 4, title: 'شیمی دهم نوبت دوم - سری 2' },
    { id: 5, title: 'شیمی دهم نوبت دوم - سری 3' },
    { id: 6, title: 'شیمی دهم نوبت دوم - سری 4' },
    { id: 7, title: 'شیمی دهم نوبت دوم - سری 5' },
  ],
  308: [
    { id: 1, title: 'فیزیک 1 رشته ریاضی خرداد 1402' },
    { id: 2, title: 'فیزیک 1 رشته ریاضی شهریور 1402' },
    { id: 3, title: 'فیزیک 1 رشته ریاضی صبح خرداد 1402' },
    { id: 4, title: 'فیزیک 1 رشته ریاضی فروردین 1402' },
    { id: 5, title: 'فیزیک 1 رشته ریاضی نوبت عصر خرداد 1402' },
    { id: 6, title: 'نهایی فیزیک 1 رشته ریاضی خرداد 1403' },
    { id: 7, title: 'امتحان نهایی فیزیک دهم ریاضی خرداد 1403' },
  ],
  309: [
    { id: 1, title: 'امتحان زیست دهم نوبت دوم' },
    { id: 2, title: 'امتحان شبه نهایی زیست 1 نوبت عصر اردیبهشت 1403' },
    { id: 3, title: 'امتحان نهایی زیست دهم خرداد 1403' },
    { id: 4, title: 'امتحان نهایی زیست دهم شهریور1402' },
    { id: 5, title: 'امتحان نهایی زیست دهم نوبت صبح خرداد 1402' },
    { id: 6, title: 'امتحان نهایی زیست دهم نوبت عصر خرداد 1402' },
  ],
  310: [
    { id: 1, title: 'نمونه سوالات امتحانی علوم و فنون ادبی دهم انسانی - سری 2' },
    { id: 2, title: 'نمونه سوالات امتحانی علوم و فنون ادبی دهم انسانی - سری 3' },
    { id: 3, title: 'نمونه سوالات امتحانی علوم و فنون ادبی دهم انسانی - سری 4' },
    { id: 4, title: 'نمونه سوالات امتحانی علوم و فنون ادبی دهم انسانی - سری 5' },
    { id: 5, title: 'نمونه سوالات امتحانی علوم و فنون ادبی دهم انسانی - سری 6' },
    { id: 6, title: 'نمونه سوالات نهایی علوم و فنون ادبی دهم انسانی - سری 1' },
  ],
  311: [
    { id: 1, title: 'نمونه سوالات امتحان شبه نهایی عربی دهم انسانی - سری 6' },
    { id: 2, title: 'نمونه سوالات امتحان نهایی عربی دهم انسانی - سری 1' },
    { id: 3, title: 'نمونه سوالات امتحان نهایی عربی دهم انسانی - سری 2' },
    { id: 4, title: 'نمونه سوالات امتحان نهایی عربی دهم انسانی - سری 3' },
    { id: 5, title: 'نمونه سوالات امتحان نهایی عربی دهم انسانی - سری 4' },
    { id: 6, title: 'نمونه سوالات امتحان نهایی عربی دهم انسانی - سری 5' },
  ],
  312: [
    { id: 1, title: 'نمونه سوالات امتحانی تاریخ دهم انسانی - سری 2' },
    { id: 2, title: 'نمونه سوالات امتحانی تاریخ دهم انسانی - سری 3' },
    { id: 3, title: 'نمونه سوالات امتحانی تاریخ دهم انسانی - سری 4' },
    { id: 4, title: 'نمونه سوالات امتحانی تاریخ دهم انسانی - سری 5' },
    { id: 5, title: 'نمونه سوالات امتحانی تاریخ دهم انسانی - سری 6' },
    { id: 6, title: 'نمونه سوالات نهایی تاریخ دهم انسانی - سری 1' },
  ],
  313: [
    { id: 1, title: 'نمونه سوالات امتحانی اقتصاد دهم انسانی - سری 2' },
    { id: 2, title: 'نمونه سوالات امتحانی اقتصاد دهم انسانی - سری 3' },
    { id: 3, title: 'نمونه سوالات امتحانی اقتصاد دهم انسانی - سری 4' },
    { id: 4, title: 'نمونه سوالات امتحانی اقتصاد دهم انسانی - سری 5' },
    { id: 5, title: 'نمونه سوالات امتحانی اقتصاد دهم انسانی - سری 6' },
    { id: 6, title: 'نمونه سوالات نهایی اقتصاد دهم انسانی - سری 1' },
  ],
  314: [
    { id: 1, title: 'نمونه سوالات امتحانی جامعه شناسی دهم انسانی - سری 4' },
    { id: 2, title: 'نمونه سوالات امتحانی جامعه شناسی دهم انسانی - سری 5' },
    { id: 3, title: 'نمونه سوالات امتحانی جامعه شناسی دهم انسانی - سری 6' },
    { id: 4, title: 'نمونه سوالات شبه نهایی جامعه شناسی دهم انسانی - سری 2' },
    { id: 5, title: 'نمونه سوالات شبه نهایی جامعه شناسی دهم انسانی - سری 3' },
    { id: 6, title: 'نمونه سوالات نهایی جامعه شناسی دهم انسانی - سری 1' },
  ],
  315: [
    { id: 1, title: 'امتحان نهایی جغرافی دهم  خرداد 1403' },
    { id: 2, title: 'جغرافی دهم نوبت دوم - سری 1' },
    { id: 3, title: 'جغرافی دهم نوبت دوم - سری 2' },
    { id: 4, title: 'جغرافی دهم نوبت دوم - سری 3' },
    { id: 5, title: 'جغرافی دهم نوبت دوم - سری 4' },
    { id: 6, title: 'جغرافی دهم نوبت دوم - سری 5' },
    { id: 7, title: 'جغرافی دهم نوبت دوم - سری 6' },
  ],
  316: [
    { id: 1, title: 'امتحان نهایی فارسی 1 نوبت صبح خرداد 1402' },
    { id: 2, title: 'امتحان نهایی فارسی 1 نوبت عصر خرداد 1402' },
    { id: 3, title: 'شبه نهایی فارسی 1 نوبت صبح اردیبهشت 1403' },
    { id: 4, title: 'شبه نهایی فارسی 1 نوبت عصر اردیبهشت 1403' },
    { id: 5, title: 'نهایی فارسی 1 تجربی و ریاضی شهریور 1402' },
    { id: 6, title: 'نهایی فارسی 1 رشته ریاضی و تجربی خرداد 1403' },
  ],
  317: [
    { id: 1, title: 'امتحان نهایی فارسی دهم انسانی نوبت صبح خرداد 1402' },
    { id: 2, title: 'امتحان نهایی فارسی دهم انسانی نوبت عصر خرداد 1402' },
    { id: 3, title: 'شبه نهایی فارسی دهم انسانی نوبت صبح اردیبهشت 1403' },
    { id: 4, title: 'شبه نهایی فارسی دهم انسانی نوبت عصر اردیبهشت 1403' },
    { id: 5, title: 'نمونه سوالات نهایی فارسی دهم انسانی خرداد 1403' },
    { id: 6, title: 'نمونه سوالات نهایی فارسی دهم انسانی شهریور 1402' },
  ],
  318: [
    { id: 1, title: 'امتحان نهایی فارسی 1 نوبت صبح خرداد 1402' },
    { id: 2, title: 'امتحان نهایی فارسی 1 نوبت عصر خرداد 1402' },
    { id: 3, title: 'شبه نهایی فارسی 1 نوبت صبح اردیبهشت 1403' },
    { id: 4, title: 'شبه نهایی فارسی 1 نوبت عصر اردیبهشت 1403' },
    { id: 5, title: 'نهایی فارسی 1 تجربی و ریاضی شهریور 1402' },
    { id: 6, title: 'نهایی فارسی 1 رشته ریاضی و تجربی خرداد 1403' },
  ],
  319: [
    { id: 1, title: 'زبان انگلیسی دهم  - سری 1' },
    { id: 2, title: 'زبان انگلیسی دهم  - سری 2' },
    { id: 3, title: 'زبان انگلیسی دهم  - سری 3' },
    { id: 4, title: 'زبان انگلیسی دهم  - سری 4' },
    { id: 5, title: 'زبان انگلیسی دهم  - سری 5' },
    { id: 6, title: 'شبه نهایی انگلیسی1 نوبت صبح اردیبهشت 1403' },
    { id: 7, title: 'شبه نهایی انگلیسی1 نوبت عصر اردیبهشت 1403' },
    { id: 8, title: 'امتحان نهایی انگلیسی دهم ریاضی خرداد 1403' },
  ],
  320: [
    { id: 1, title: 'زبان انگلیسی دهم  - سری 1' },
    { id: 2, title: 'زبان انگلیسی دهم  - سری 2' },
    { id: 3, title: 'زبان انگلیسی دهم  - سری 3' },
    { id: 4, title: 'زبان انگلیسی دهم  - سری 4' },
    { id: 5, title: 'زبان انگلیسی دهم  - سری 5' },
    { id: 6, title: 'شبه نهایی انگلیسی1 نوبت صبح اردیبهشت 1403' },
    { id: 7, title: 'شبه نهایی انگلیسی1 نوبت عصر اردیبهشت 1403' },
  ],
  321: [
    { id: 1, title: 'زبان انگلیسی دهم  - سری 1' },
    { id: 2, title: 'زبان انگلیسی دهم  - سری 2' },
    { id: 3, title: 'زبان انگلیسی دهم  - سری 3' },
    { id: 4, title: 'زبان انگلیسی دهم  - سری 4' },
    { id: 5, title: 'زبان انگلیسی دهم  - سری 5' },
    { id: 6, title: 'شبه نهایی انگلیسی1 نوبت صبح اردیبهشت 1403' },
    { id: 7, title: 'شبه نهایی انگلیسی1 نوبت عصر اردیبهشت 1403' },
    { id: 8, title: 'امتحان نهایی انگلیسی دهم تجربی خرداد 1403' },
  ],
  322: [
    { id: 1, title: 'امتحان نهایی دین و زندگی 1 خرداد 1403' },
    { id: 2, title: 'دین و زندگی دهم نوبت دوم - سری 1' },
    { id: 3, title: 'دین و زندگی دهم نوبت دوم - سری 2' },
    { id: 4, title: 'دین و زندگی دهم نوبت دوم - سری 3' },
    { id: 5, title: 'دین و زندگی دهم نوبت دوم - سری 4' },
    { id: 6, title: 'دین و زندگی دهم نوبت دوم - سری 5' },
    { id: 7, title: 'دین و زندگی دهم نوبت دوم - سری 6' },
  ],
  323: [
    { id: 1, title: 'امتحان نهایی دین و زندگی 1 خرداد 1403' },
    { id: 2, title: 'دین و زندگی دهم نوبت دوم - سری 1' },
    { id: 3, title: 'دین و زندگی دهم نوبت دوم - سری 2' },
    { id: 4, title: 'دین و زندگی دهم نوبت دوم - سری 3' },
    { id: 5, title: 'دین و زندگی دهم نوبت دوم - سری 4' },
    { id: 6, title: 'دین و زندگی دهم نوبت دوم - سری 5' },
    { id: 7, title: 'دین و زندگی دهم نوبت دوم - سری 6' },
  ],
  324: [
    { id: 1, title: 'نمونه سوالات امتحانی دین وزندگی دهم انسانی - سری 2' },
    { id: 2, title: 'نمونه سوالات امتحانی دین وزندگی دهم انسانی - سری 3' },
    { id: 3, title: 'نمونه سوالات امتحانی دین وزندگی دهم انسانی - سری 4' },
    { id: 4, title: 'نمونه سوالات امتحانی دین وزندگی دهم انسانی - سری 5' },
    { id: 5, title: 'نمونه سوالات امتحانی دین وزندگی دهم انسانی - سری 6' },
    { id: 6, title: 'نمونه سوالات نهایی دین و زندگی دهم انسانی - سری 1' },
  ],
  325: [
    { id: 1, title: 'نمونه سوال امتحان نهایی ریاضی و آمار یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان نهایی ریاضی و آمار یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان نهایی ریاضی و آمار یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان نهایی ریاضی و آمار یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی و آمار یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی و آمار یازدهم انسانی - سری 6' },
  ],
  326: [
    { id: 1, title: 'نمونه سوال امتحان نهایی ریاضی یازدهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان نهایی ریاضی یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان نهایی ریاضی یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان نهایی ریاضی یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی یازدهم تجربی - سری 6' },
  ],
  327: [
    { id: 1, title: 'نمونه سوال امتحان نهایی حسابان یازدهم ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان نهایی حسابان یازدهم ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان نهایی حسابان یازدهم ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان نهایی حسابان یازدهم ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی حسابان یازدهم ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی حسابان یازدهم ریاضی - سری 6' },
  ],
  328: [
    { id: 1, title: 'نمونه سوال امتحان نهایی هندسه یازدهم ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی هندسه یازدهم ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی هندسه یازدهم ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی هندسه یازدهم ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی هندسه یازدهم ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی هندسه یازدهم ریاضی - سری 6' },
  ],
  329: [
    { id: 1, title: 'نمونه سوال امتحان نهایی  آمار و احتمال یازدهم ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی  آمار و احتمال یازدهم ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی  آمار و احتمال یازدهم ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی  آمار و احتمال یازدهم ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی  آمار و احتمال یازدهم ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی  آمار و احتمال یازدهم ریاضی - سری 6' },
  ],
  330: [
    { id: 1, title: 'نمونه سوال امتحان نهایی شیمی یازدهم ریاضی- سری1' },
    { id: 2, title: 'نمونه سوال امتحانی شیمی یازدهم ریاضی- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی شیمی یازدهم ریاضی- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی شیمی یازدهم ریاضی- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی شیمی یازدهم ریاضی- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی شیمی یازدهم ریاضی- سری 6' },
  ],
  331: [
    { id: 1, title: 'نمونه سوال امتحان نهایی شیمی یازدهم تجربی - سری1' },
    { id: 2, title: 'نمونه سوال امتحانی شیمی یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی شیمی یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی شیمی یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی شیمی یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی شیمی یازدهم تجربی - سری 6' },
  ],
  332: [
    { id: 1, title: 'نمونه سوال امتحان نهایی فیزیک یازدهم ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فیزیک یازدهم ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فیزیک یازدهم ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فیزیک یازدهم ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فیزیک یازدهم ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فیزیک یازدهم ریاضی - سری 6' },
    { id: 7, title: 'نمونه سوال امتحانی فیزیک یازدهم ریاضی - سری 7' },
  ],
  333: [
    { id: 1, title: 'نمونه سوال امتحان نهایی فیزیک یازدهم تجربی  - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فیزیک یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فیزیک یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فیزیک یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فیزیک یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فیزیک یازدهم تجربی - سری 6' },
  ],
  334: [
    { id: 1, title: 'نمونه سوال امتحان نهایی زیست یازدهم تجربی سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی زیست یازدهم تجربی سری2' },
    { id: 3, title: 'نمونه سوال امتحانی زیست یازدهم تجربی سری3' },
    { id: 4, title: 'نمونه سوال امتحانی زیست یازدهم تجربی سری4' },
    { id: 5, title: 'نمونه سوال امتحانی زیست یازدهم تجربی سری5' },
    { id: 6, title: 'نمونه سوال امتحانی زیست یازدهم تجربی سری6' },
  ],
  335: [
    { id: 1, title: 'نمونه سوال امتحان نهایی علوم و فنون یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان نهایی علوم و فنون یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان نهایی علوم و فنون یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان نهایی علوم و فنون یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم و فنون یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی علوم و فنون یازدهم انسانی - سری 6' },
  ],
  336: [
    { id: 1, title: 'نمونه سوال امتحان نهایی عربی یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی عربی یازدهم انسانی -سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی عربی یازدهم انسانی -سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی عربی یازدهم انسانی -سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی عربی یازدهم انسانی -سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی عربی یازدهم انسانی -سری 6' },
    { id: 7, title: 'امتحان نهایی عربی یازدهم انسانی خرداد 1404' },
  ],
  337: [
    { id: 1, title: 'نمونه سوال امتحان نهایی تاریخ یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی تاریخ یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی تاریخ یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی تاریخ یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی تاریخ یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی تاریخ یازدهم انسانی - سری 6' },
  ],
  338: [
    { id: 1, title: 'نمونه سوال امتحان نهایی جامعه شناسی یازدهم انسانی - سری1' },
    { id: 2, title: 'نمونه سوال امتحانی جامعه شناسی یازدهم انسانی - سری2' },
    { id: 3, title: 'نمونه سوال امتحانی جامعه شناسی یازدهم انسانی - سری3' },
    { id: 4, title: 'نمونه سوال امتحانی جامعه شناسی یازدهم انسانی - سری4' },
    { id: 5, title: 'نمونه سوال امتحانی جامعه شناسی یازدهم انسانی - سری5' },
    { id: 6, title: 'نمونه سوال امتحانی جامعه شناسی یازدهم انسانی - سری6' },
  ],
  339: [
    { id: 1, title: 'نمونه سوال امتحان نهایی جغرافیا یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی جغرافیا یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی جغرافیا یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی جغرافیا یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی جغرافیا یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی جغرافیا یازدهم انسانی - سری 6' },
  ],
  340: [
    { id: 1, title: 'نمونه سوال امتحان فارسی یازدهم ریاضی - سری 2' },
    { id: 2, title: 'نمونه سوال امتحان فارسی یازدهم ریاضی - سری 3' },
    { id: 3, title: 'نمونه سوال امتحان فارسی یازدهم ریاضی - سری 4' },
    { id: 4, title: 'نمونه سوال امتحان فارسی یازدهم ریاضی - سری 5' },
    { id: 5, title: 'نمونه سوال امتحان فارسی یازدهم ریاضی - سری 6' },
    { id: 6, title: 'نمونه سوال امتحان فارسی یازدهم ریاضی- سری 1' },
    { id: 7, title: 'امتحان نهایی فارسی یازدهم ریاضی خرداد 1404' },
  ],
  341: [
    { id: 1, title: 'نمونه سوال امتحان فارسی یازدهم انسانی- سری 1' },
    { id: 2, title: 'نمونه سوال امتحان فارسی یازدهم انسانی- سری 2' },
    { id: 3, title: 'نمونه سوال امتحان فارسی یازدهم انسانی- سری 3' },
    { id: 4, title: 'نمونه سوال امتحان فارسی یازدهم انسانی- سری 4' },
    { id: 5, title: 'نمونه سوال امتحان فارسی یازدهم انسانی- سری 5' },
    { id: 6, title: 'نمونه سوال امتحان فارسی یازدهم انسانی- سری 6' },
    { id: 7, title: 'امتحان نهایی فارسی یازدهم انسانی خرداد 1404' },
  ],
  342: [
    { id: 1, title: 'نمونه سوال امتحان فارسی یازدهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان فارسی یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان فارسی یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان فارسی یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان فارسی یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحان فارسی یازدهم تجربی - سری 6' },
    { id: 7, title: 'امتحان نهایی فارسی یازدهم تجربی خرداد 1404' },
  ],
  343: [
    { id: 1, title: 'نمونه سوال امتحان نهایی زبان انگلیسی یازدهم ریاضی- سری 1' },
    { id: 2, title: 'نمونه سوال زبان انگلیسی یازدهم ریاضی- سری 2' },
    { id: 3, title: 'نمونه سوال زبان انگلیسی یازدهم ریاضی- سری 3' },
    { id: 4, title: 'نمونه سوال زبان انگلیسی یازدهم ریاضی- سری 4' },
    { id: 5, title: 'نمونه سوال زبان انگلیسی یازدهم ریاضی- سری 5' },
    { id: 6, title: 'نمونه سوال زبان انگلیسی یازدهم ریاضی- سری 6' },
  ],
  344: [
    { id: 1, title: 'نمونه سوال امتحان نهایی زبان انگلیسی یازدهم انسانی- سری 1' },
    { id: 2, title: 'نمونه سوال زبان انگلیسی یازدهم انسانی- سری 2' },
    { id: 3, title: 'نمونه سوال زبان انگلیسی یازدهم انسانی- سری 3' },
    { id: 4, title: 'نمونه سوال زبان انگلیسی یازدهم انسانی- سری 4' },
    { id: 5, title: 'نمونه سوال زبان انگلیسی یازدهم انسانی- سری 5' },
    { id: 6, title: 'نمونه سوال زبان انگلیسی یازدهم انسانی- سری 6' },
  ],
  345: [
    { id: 1, title: 'نمونه سوال امتحان نهایی زبان انگلیسی یازدهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال زبان انگلیسی یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال زبان انگلیسی یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال زبان انگلیسی یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال زبان انگلیسی یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال زبان انگلیسی یازدهم تجربی - سری 6' },
  ],
  346: [
    { id: 1, title: 'نمونه سوال امتحان نهایی عربی یازدهم ریاضی- سری 1' },
    { id: 2, title: 'نمونه سوال امتحان نهایی عربی یازدهم ریاضی- سری 2' },
    { id: 3, title: 'نمونه سوال امتحان نهایی عربی یازدهم ریاضی- سری 3' },
    { id: 4, title: 'نمونه سوال امتحان نهایی عربی یازدهم ریاضی- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی عربی یازدهم ریاضی- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی عربی یازدهم ریاضی- سری 6' },
    { id: 7, title: 'امتحان نهایی عربی یازدهم ریاضی خرداد 1404' },
  ],
  347: [
    { id: 1, title: 'نمونه سوال امتحان نهایی عربی یازدهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان نهایی عربی یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان نهایی عربی یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان نهایی عربی یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی عربی یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی عربی یازدهم تجربی - سری 6' },
    { id: 7, title: 'امتحان نهایی عربی یازدهم تجربی خرداد 1404' },
  ],
  348: [
    { id: 1, title: 'نمونه سوال امتحان نهایی فلسفه یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فلسفه یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فلسفه یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فلسفه یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فلسفه یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فلسفه یازدهم انسانی - سری 6' },
  ],
  349: [
    { id: 1, title: 'نمونه سوال امتحان نهایی زمین یازدهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی زمین یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی زمین یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی زمین یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی زمین یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی زمین یازدهم تجربی - سری 6' },
  ],
  350: [
    { id: 1, title: 'نمونه سوال امتحانی دین و زندگی یازدهم ریاضی- سری 2' },
    { id: 2, title: 'نمونه سوال امتحانی دین و زندگی یازدهم ریاضی- سری 3' },
    { id: 3, title: 'نمونه سوال امتحانی دین و زندگی یازدهم ریاضی- سری 4' },
    { id: 4, title: 'نمونه سوال امتحانی دین و زندگی یازدهم ریاضی- سری 5' },
    { id: 5, title: 'نمونه سوال امتحانی دین و زندگی یازدهم ریاضی- سری 6' },
    { id: 6, title: 'نمونه وسال امتحان نهایی دین وزندگی یازدهم ریاضی- سری 1' },
    { id: 7, title: 'امتحان نهایی دین و زندگی یازدهم ریاضی خرداد 1404' },
  ],
  351: [
    { id: 1, title: 'نمونه سوال امتحانی دین و زندگی یازدهم تجربی - سری 2' },
    { id: 2, title: 'نمونه سوال امتحانی دین و زندگی یازدهم تجربی - سری 3' },
    { id: 3, title: 'نمونه سوال امتحانی دین و زندگی یازدهم تجربی - سری 4' },
    { id: 4, title: 'نمونه سوال امتحانی دین و زندگی یازدهم تجربی - سری 5' },
    { id: 5, title: 'نمونه سوال امتحانی دین و زندگی یازدهم تجربی - سری 6' },
    { id: 6, title: 'نمونه وسال امتحان نهایی دین وزندگی یازدهم تجربی - سری 1' },
    { id: 7, title: 'امتحان نهایی دین و زندگی یازدهم تجربی خرداد 1404' },
  ],
  352: [
    { id: 1, title: 'نمونه سوال امتحان نهایی روانشناسی یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی روانشناسی یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی روانشناسی یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی روانشناسی یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی روانشناسی یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی روانشناسی یازدهم انسانی - سری 6' },
  ],
  353: [
    { id: 1, title: 'امتحان نهایی ریاضی و آمار دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی ریاضی و آمار دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی ریاضی و آمار دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی ریاضی و آمار دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی ریاضی و آمار دوازدهم انسانی شهریور 1402' },
    { id: 6, title: 'امتحان نهایی ریاضی و آمار دوازدهم انسانی شهریور1401' },
    { id: 7, title: 'امتحان نهایی ریاضی و آمار دوازدهم انسانی دی 1403' },
    { id: 8, title: 'امتحان نهایی ریاضی و آمار دوازدهم انسانی مرداد 1403' },
  ],
  354: [
    { id: 1, title: 'امتحان نهایی ریاضی دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی ریاضی دوازدهم تجربی خرداد 1402 ' },
    { id: 3, title: 'امتحان نهایی ریاضی دوازدهم تجربی دی 1403' },
    { id: 4, title: 'امتحان نهایی ریاضی دوازدهم تجربی دی ماه 1401' },
    { id: 5, title: 'امتحان نهایی ریاضی دوازدهم تجربی دی ماه 1402' },
    { id: 6, title: 'امتحان نهایی ریاضی دوازدهم تجربی شهریور 1401 ' },
    { id: 7, title: 'امتحان نهایی ریاضی دوازدهم تجربی شهریور 1402' },
    { id: 8, title: 'امتحان نهایی ریاضی دوازدهم تجربی مرداد 1403' },
  ],
  355: [
    { id: 1, title: 'امتحان نهایی حسابان دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی حسابان دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی حسابان دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی حسابان دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی حسابان دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی حسابان دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی حسابان دوازدهم ریاضی دی 1403' },
    { id: 8, title: 'امتحان نهایی حسابان دوازدهم ریاضی مرداد 1403' },
  ],
  356: [
    { id: 1, title: 'امتحان نهایی هندسه دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی هندسه دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی هندسه دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی هندسه دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی هندسه دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی هندسه دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی هندسه دوازدهم ریاضی دی 1403' },
    { id: 8, title: 'امتحان نهایی هندسه دوازدهم ریاضی مرداد 1403' },
  ],
  357: [
    { id: 1, title: 'امتحان نهایی ریاضیات گسسته دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی ریاضیات گسسته دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی ریاضیات گسسته دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی ریاضیات گسسته دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی ریاضیات گسسته دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی ریاضیات گسسته دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی ریاضیات گسسته دوازدهم ریاضی دی 1403' },
    { id: 8, title: 'امتحان نهایی ریاضیات گسسته دوازدهم ریاضی مرداد 1403' },
  ],
  358: [
    { id: 1, title: 'امتحان نهایی شیمی دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی شیمی دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی شیمی دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی شیمی دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی شیمی دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی شیمی دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی شیمی دوازدهم ریاضی دی 1403' },
    { id: 8, title: 'امتحان نهایی شیمی دوازدهم ریاضی مرداد 1403' },
  ],
  359: [
    { id: 1, title: 'امتحان نهایی شیمی دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی شیمی دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی شیمی دوازدهم تجربی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی شیمی دوازدهم تجربی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی شیمی دوازدهم تجربی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی شیمی دوازدهم تجربی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی شیمی دوازدهم تجربی دی 1403' },
    { id: 8, title: 'امتحان نهایی شیمی دوازدهم تجربی مرداد 1403' },
  ],
  360: [
    { id: 1, title: 'امتحان نهایی فیزیک دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی فیزیک دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی فیزیک دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی فیزیک دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی فیزیک دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی فیزیک دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی فیزیک دوازدهم ریاضی مرداد 1403' },
    { id: 8, title: 'امتحان نهایی فیزیک دوازدهم ریاضی دی 1403' },
    { id: 9, title: 'امتحان نهایی فیزیک دوازدهم ریاضی خرداد 1404' },
  ],
  361: [
    { id: 1, title: 'امتحان نهایی فیزیک دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی فیزیک دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی فیزیک دوازدهم تجربی خرداد 1404' },
    { id: 4, title: 'امتحان نهایی فیزیک دوازدهم تجربی دی 1403' },
    { id: 5, title: 'امتحان نهایی فیزیک دوازدهم تجربی دی ماه 1401' },
    { id: 6, title: 'امتحان نهایی فیزیک دوازدهم تجربی دی ماه 1402' },
    { id: 7, title: 'امتحان نهایی فیزیک دوازدهم تجربی شهریور 1401' },
    { id: 8, title: 'امتحان نهایی فیزیک دوازدهم تجربی شهریور 1402' },
    { id: 9, title: 'امتحان نهایی فیزیک دوازدهم تجربی مرداد 1403' },
  ],
  362: [
    { id: 1, title: 'امتحان نهایی علوم و فنون دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی علوم و فنون دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی علوم و فنون دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی علوم و فنون دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی علوم و فنون دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی علوم و فنون دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی علوم و فنون ادبی دوازدهم انسانی دی 1403' },
    { id: 8, title: 'امتحان نهایی علوم و فنون ادبی دوازدهم انسانی مرداد 1403' },
  ],
  363: [
    { id: 1, title: 'امتحان نهایی عربی دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی عربی دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی عربی دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی عربی دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی عربی دوازدهم انسانی شهریور 1402' },
    { id: 6, title: 'امتحان نهایی عربی دوازدهم انسانی شهریور1401' },
    { id: 7, title: 'امتحان نهایی عربی دوازدهم انسانی دی 1403' },
    { id: 8, title: 'امتحان نهایی عربی دوازدهم انسانی مرداد 1403' },
  ],
  364: [
    { id: 1, title: 'امتحان نهایی تاریخ دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی تاریخ دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی تاریخ دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی تاریخ دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی تاریخ دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی تاریخ دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی تاریخ دوازدهم انسانی دی 1403' },
    { id: 8, title: 'امتحان نهایی تاریخ دوازدهم انسانی مرداد 1403' },
  ],
  365: [
    { id: 1, title: 'امتحان نهایی فلسفه دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی فلسفه دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی فلسفه دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی فلسفه دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی فلسفه دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی فلسفه دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی فلسفه دوازدهم انسانی خرداد 1404' },
    { id: 8, title: 'امتحان نهایی فلسفه دوازدهم انسانی دی 1403' },
    { id: 9, title: 'امتحان نهایی فلسفه دوازدهم انسانی مرداد 1403' },
  ],
  366: [
    { id: 1, title: 'امتحان نهایی جامعه شناسی دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی جامعه شناسی دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی جامعه شناسی دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی جامعه شناسی دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی جامعه شناسی دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی جامعه شناسی دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی جامعه شناسی دوازدهم انسانی دی 1403' },
    { id: 8, title: 'امتحان نهایی جامعه شناسی دوازدهم انسانی مرداد 1403' },
  ],
  367: [
    { id: 1, title: 'امتحان نهایی جغرافی دوازدهم انسانی  خرداد 1401' },
    { id: 2, title: 'امتحان نهایی جغرافی دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی جغرافی دوازدهم انسانی دیماه 1401' },
    { id: 4, title: 'امتحان نهایی جغرافی دوازدهم انسانی دیماه 1402' },
    { id: 5, title: 'امتحان نهایی جغرافی دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی جغرافی دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی جغرافیا دوازدهم انسانی دی 1403' },
    { id: 8, title: 'امتحان نهایی جغرافیا دوازدهم انسانی مرداد 1403' },
  ],
  368: [
    { id: 1, title: 'امتحان نهایی فارسی دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی فارسی دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی فارسی دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی فارسی دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی فارسی دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی فارسی دوازدهم ریاضی شهریور1402' },
    { id: 7, title: 'امتحان نهایی فارسی دوازدهم ریاضی مرداد 1403' },
    { id: 8, title: 'امتحان نهایی فارسی دوازدهم ریاضی دی 1403' },
    { id: 9, title: 'امتحان نهایی فارسی دوازدهم ریاضی خرداد 1404' },
  ],
  369: [
    { id: 1, title: 'امتحان نهایی فارسی دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی فارسی دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی فارسی دوازدهم تجربی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی فارسی دوازدهم تجربی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی فارسی دوازدهم تجربی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی فارسی دوازدهم تجربی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی فارسی دوازدهم تجربی خرداد 1404' },
    { id: 8, title: 'امتحان نهایی فارسی دوازدهم تجربی دی 1403' },
    { id: 9, title: 'امتحان نهایی فارسی دوازدهم تجربی مرداد 1403' },
  ],
  370: [
    { id: 1, title: 'امتحان نهایی فارسی دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی فارسی دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی فارسی دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی فارسی دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی فارسی دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی فارسی دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی فارسی دوازدهم انسانی خرداد 1404' },
    { id: 8, title: 'امتحان نهایی فارسی دوازدهم انسانی دی 1403' },
    { id: 9, title: 'امتحان نهایی فارسی دوازدهم انسانی مرداد 1403' },
  ],
  371: [
    { id: 1, title: 'امتحان نهایی زبان دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی زبان دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی زبان دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی زبان دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی زبان دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی زبان دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی انگلیسی دوازدهم ریاضی دی 1403' },
    { id: 8, title: 'امتحان نهایی انگلیسی دوازدهم ریاضی مرداد 1403' },
  ],
  372: [
    { id: 1, title: 'امتحان نهایی زبان دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی زبان دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی زبان دوازدهم تجربی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی زبان دوازدهم تجربی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی زبان دوازدهم تجربی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی زبان دوازدهم تجربی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی انگلیسی دوازدهم تجربی دی 1403' },
    { id: 8, title: 'امتحان نهایی انگلیسی دوازدهم تجربی مرداد 1403' },
  ],
  373: [
    { id: 1, title: 'امتحان نهایی انگلیسی دوازدهم انسانی  خرداد 1401' },
    { id: 2, title: 'امتحان نهایی انگلیسی دوازدهم انسانی  خرداد 1402' },
    { id: 3, title: 'امتحان نهایی انگلیسی دوازدهم انسانی  دی ماه 1402' },
    { id: 4, title: 'امتحان نهایی انگلیسی دوازدهم انسانی دی ماه 1401' },
    { id: 5, title: 'امتحان نهایی انگلیسی دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی انگلیسی دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی انگلیسی دوازدهم انسانی دی 1403' },
    { id: 8, title: 'امتحان نهایی انگلیسی دوازدهم انسانی مرداد 1403' },
  ],
  374: [
    { id: 1, title: 'امتحان نهایی عربی دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی عربی دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی عربی دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی عربی دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی عربی دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی عربی دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی عربی دوازدهم ریاضی دی 1403' },
    { id: 8, title: 'امتحان نهایی عربی دوازدهم ریاضی مرداد 1403' },
  ],
  375: [
    { id: 1, title: 'امتحان نهایی عربی دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی عربی دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی عربی دوازدهم تجربی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی عربی دوازدهم تجربی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی عربی دوازدهم تجربی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی عربی دوازدهم تجربی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی عربی دوازدهم تجربی دی 1403' },
    { id: 8, title: 'امتحان نهایی عربی دوازدهم تجربی مرداد 1403' },
  ],
  376: [
    { id: 1, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی دی 1401' },
    { id: 4, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی دی 1402' },
    { id: 5, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی مرداد 1403' },
    { id: 8, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی دی 1403' },
    { id: 9, title: 'امتحان نهایی دین و زندگی دوازدهم ریاضی خرداد 1404' },
  ],
  377: [
    { id: 1, title: 'امتحان نهایی دین وزندگی دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی دین وزندگی دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی دین وزندگی دوازدهم تجربی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی دین وزندگی دوازدهم تجربی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی دین وزندگی دوازدهم تجربی شهریور 1402' },
    { id: 6, title: 'امتحان نهایی دین وزندگی دوازدهم تجربی شهریور1401' },
    { id: 7, title: 'امتحان نهایی دین و زندگی دوازدهم تجربی خرداد 1404' },
    { id: 8, title: 'امتحان نهایی دین و زندگی دوازدهم تجربی دی 1403' },
    { id: 9, title: 'امتحان نهایی دین و زندگی دوازدهم تجربی مرداد 1403' },
  ],
  378: [
    { id: 1, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی خرداد 1404' },
    { id: 8, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی دی 1403' },
    { id: 9, title: 'امتحان نهایی دین و زندگی دوازدهم انسانی مرداد 1403' },
  ],
  379: [
    { id: 1, title: 'نمونه سوالات امتحانی منطق دهم انسانی  - سری 1' },
    { id: 2, title: 'نمونه سوالات امتحانی منطق دهم انسانی  - سری 2' },
    { id: 3, title: 'نمونه سوالات امتحانی منطق دهم انسانی  - سری 3' },
    { id: 4, title: 'نمونه سوالات امتحانی منطق دهم انسانی  - سری 4' },
    { id: 5, title: 'نمونه سوالات امتحانی منطق دهم انسانی  - سری 5' },
    { id: 6, title: 'نمونه سوالات امتحانی منطق دهم انسانی  - سری 6' },
  ],
  380: [
    { id: 1, title: 'امتحان نهایی زیست دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی زیست دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی زیست دوازدهم تجربی دی 1401' },
    { id: 4, title: 'امتحان نهایی زیست دوازدهم تجربی دی 1402' },
    { id: 5, title: 'امتحان نهایی زیست دوازدهم تجربی دی 1403' },
    { id: 6, title: 'امتحان نهایی زیست دوازدهم تجربی شهریور 1401' },
    { id: 7, title: 'امتحان نهایی زیست دوازدهم تجربی شهریور 1402' },
    { id: 8, title: 'امتحان نهایی زیست دوازدهم تجربی مرداد 1403' },
  ],
  381: [
    { id: 1, title: 'نمونه سوال امتحان نهایی زمین یازدهم ریاضی- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی زمین یازدهم ریاضی- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی زمین یازدهم ریاضی- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی زمین یازدهم ریاضی- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی زمین یازدهم ریاضی- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی زمین یازدهم ریاضی- سری 6' },
  ],
  382: [
    { id: 1, title: 'امتحان شبه نهایی فیزیک 1 تجربی فروردین 1403' },
    { id: 2, title: 'امتحان فیزیک 1 تجربی اردیبهشت 1402' },
    { id: 3, title: 'امتحان فیزیک 1 رشته تجربی نوبت دوم خرداد 1401' },
    { id: 4, title: 'امتحان فیزیک 1 رشته تجربی نوبت دوم خرداد 1402' },
    { id: 5, title: 'امتحان فیزیک 1 رشته تجربی نوبت دوم' },
    { id: 6, title: 'امتحان نهایی فیزیک 1 تجربی خرداد 1403' },
  ],
  383: [
    { id: 1, title: 'امتحان شبه نهایی عربی دهم نوبت صبح اردیبهشت 1403' },
    { id: 2, title: 'امتحان شبه نهایی عربی دهم نوبت عصر اردیبهشت 1403' },
    { id: 3, title: 'امتحان نهایی عربی دهم ریاضی-تجربی خرداد 1403' },
    { id: 4, title: 'عربی 1 ریاض و تجربی فروردین 1402' },
    { id: 5, title: 'عربی 1 ریاضی و تجربی فروردین 1402' },
    { id: 6, title: 'عربی دهم ریاضی و تجربی نوبت دوم' },
  ],
  384: [
    { id: 1, title: 'امتحان شبه نهایی عربی دهم نوبت صبح اردیبهشت 1403' },
    { id: 2, title: 'امتحان شبه نهایی عربی دهم نوبت عصر اردیبهشت 1403' },
    { id: 3, title: 'امتحان نهایی عربی دهم ریاضی-تجربی خرداد 1403' },
    { id: 4, title: 'عربی 1 ریاض و تجربی فروردین 1402' },
    { id: 5, title: 'عربی 1 ریاضی و تجربی فروردین 1402' },
    { id: 6, title: 'عربی دهم ریاضی و تجربی نوبت دوم' },
  ],
  385: [
    { id: 1, title: 'امتحان نهایی هویت اجتماعی دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی هویت اجتماعی دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی هویت اجتماعی دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی هویت اجتماعی دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی هویت اجتماعی دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی هویت اجتماعی دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی هویت اجتماعی دوازدهم ریاضی مرداد 1403' },
    { id: 8, title: 'امتحان نهایی هویت اجتماعی دوازدهم ریاضی دی 1403' },
  ],
  386: [
    { id: 1, title: 'امتحان نهایی هویت اجتماعی دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی هویت اجتماعی دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی هویت اجتماعی دوازدهم تجربی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی هویت اجتماعی دوازدهم تجربی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی هویت اجتماعی دوازدهم تجربی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی هویت اجتماعی دوازدهم تجربی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی هویت اجتماعی دوازدهم تجربی دی 1403' },
    { id: 8, title: 'امتحان نهایی هویت اجتماعی دوازدهم تجربی مرداد 1403' },
  ],
  387: [
    { id: 1, title: 'آمادگی دفاعی دهم نوبت دوم - سری 1' },
    { id: 2, title: 'آمادگی دفاعی دهم نوبت دوم - سری 2' },
    { id: 3, title: 'آمادگی دفاعی دهم نوبت دوم - سری 3' },
    { id: 4, title: 'آمادگی دفاعی دهم نوبت دوم - سری 4' },
    { id: 5, title: 'آمادگی دفاعی دهم نوبت دوم - سری 5' },
    { id: 6, title: 'آمادگی دفاعی دهم نوبت دوم - سری 6' },
  ],
  388: [
    { id: 1, title: 'آمادگی دفاعی دهم نوبت دوم - سری 1' },
    { id: 2, title: 'آمادگی دفاعی دهم نوبت دوم - سری 2' },
    { id: 3, title: 'آمادگی دفاعی دهم نوبت دوم - سری 3' },
    { id: 4, title: 'آمادگی دفاعی دهم نوبت دوم - سری 4' },
    { id: 5, title: 'آمادگی دفاعی دهم نوبت دوم - سری 5' },
    { id: 6, title: 'آمادگی دفاعی دهم نوبت دوم - سری 6' },
  ],
  389: [
    { id: 1, title: 'آمادگی دفاعی دهم نوبت دوم - سری 1' },
    { id: 2, title: 'آمادگی دفاعی دهم نوبت دوم - سری 2' },
    { id: 3, title: 'آمادگی دفاعی دهم نوبت دوم - سری 3' },
    { id: 4, title: 'آمادگی دفاعی دهم نوبت دوم - سری 4' },
    { id: 5, title: 'آمادگی دفاعی دهم نوبت دوم - سری 5' },
    { id: 6, title: 'آمادگی دفاعی دهم نوبت دوم - سری 6' },
  ],
  390: [
    { id: 1, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 1' },
    { id: 2, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 2' },
    { id: 3, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 3' },
    { id: 4, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 4' },
    { id: 5, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 5' },
    { id: 6, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 6' },
  ],
  391: [
    { id: 1, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 1' },
    { id: 2, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 2' },
    { id: 3, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 3' },
    { id: 4, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 4' },
    { id: 5, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 5' },
    { id: 6, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 6' },
  ],
  392: [
    { id: 1, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 1' },
    { id: 2, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 2' },
    { id: 3, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 3' },
    { id: 4, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 4' },
    { id: 5, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 5' },
    { id: 6, title: 'تفکر و سواد رسانه ای دهم نوبت دوم - سری 6' },
  ],
  393: [
    { id: 1, title: 'امتحان نهایی جغرافی دهم خرداد 1403' },
    { id: 2, title: 'جغرافی دهم نوبت دوم - سری 1' },
    { id: 3, title: 'جغرافی دهم نوبت دوم - سری 2' },
    { id: 4, title: 'جغرافی دهم نوبت دوم - سری 3' },
    { id: 5, title: 'جغرافی دهم نوبت دوم - سری 4' },
    { id: 6, title: 'جغرافی دهم نوبت دوم - سری 5' },
    { id: 7, title: 'جغرافی دهم نوبت دوم - سری 6' },
  ],
  394: [
    { id: 1, title: 'امتحان نهایی جغرافی دهم خرداد 1403' },
    { id: 2, title: 'جغرافی دهم نوبت دوم - سری 1' },
    { id: 3, title: 'جغرافی دهم نوبت دوم - سری 2' },
    { id: 4, title: 'جغرافی دهم نوبت دوم - سری 3' },
    { id: 5, title: 'جغرافی دهم نوبت دوم - سری 4' },
    { id: 6, title: 'جغرافی دهم نوبت دوم - سری 5' },
    { id: 7, title: 'جغرافی دهم نوبت دوم - سری 6' },
  ],
  395: [
    { id: 1, title: 'امتحان نگارش دهم نوبت دوم - سری 1' },
    { id: 2, title: 'امتحان نگارش دهم نوبت دوم - سری 2' },
    { id: 3, title: 'امتحان نگارش دهم نوبت دوم - سری 3' },
    { id: 4, title: 'امتحان نگارش دهم نوبت دوم - سری 4' },
    { id: 5, title: 'امتحان نگارش دهم نوبت دوم - سری 5' },
    { id: 6, title: 'امتحان نگارش دهم نوبت دوم - سری 6' },
  ],
  396: [
    { id: 1, title: 'امتحان نگارش دهم نوبت دوم - سری 1' },
    { id: 2, title: 'امتحان نگارش دهم نوبت دوم - سری 2' },
    { id: 3, title: 'امتحان نگارش دهم نوبت دوم - سری 3' },
    { id: 4, title: 'امتحان نگارش دهم نوبت دوم - سری 4' },
    { id: 5, title: 'امتحان نگارش دهم نوبت دوم - سری 5' },
    { id: 6, title: 'امتحان نگارش دهم نوبت دوم - سری 6' },
  ],
  397: [
    { id: 1, title: 'نمونه سوال امتحان نهایی تاریخ یازدهم ریاضی- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی تاریخ یازدهم ریاضی- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی تاریخ یازدهم ریاضی- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی تاریخ یازدهم ریاضی- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی تاریخ یازدهم ریاضی- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی تاریخ یازدهم ریاضی- سری 6' },
  ],
  398: [
    { id: 1, title: 'نمونه سوال امتحانی تاریخ یازدهم تجربی - سری 2' },
    { id: 2, title: 'نمونه سوال امتحانی تاریخ یازدهم تجربی - سری 3' },
    { id: 3, title: 'نمونه سوال امتحانی تاریخ یازدهم تجربی - سری 4' },
    { id: 4, title: 'نمونه سوال امتحانی تاریخ یازدهم تجربی - سری 5' },
    { id: 5, title: 'نمونه سوال امتحانی تاریخ یازدهم تجربی - سری 6' },
    { id: 6, title: 'نومنه سوال امتحان نهایی تاریخ یازدهم تجربی - سری 1' },
  ],
  399: [
    { id: 1, title: 'نمونه سوال امتحان نهایی دین و زندگی یازدهم انسانی - سری1' },
    { id: 2, title: 'نمونه سوال امتحانی دین و زندگی یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی دین و زندگی یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی دین و زندگی یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی دین و زندگی یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی دین و زندگی یازدهم انسانی - سری 6' },
    { id: 7, title: 'امتحان نهایی دین و زندگی یازدهم انسانی خرداد 1404' },
  ],
  400: [
    { id: 1, title: 'نمونه سوال امتحان نهایی محیط زیست یازدهم ریاضی- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی محیط زیست یازدهم ریاضی- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی محیط زیست یازدهم ریاضی- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی محیط زیست یازدهم ریاضی- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی محیط زیست یازدهم ریاضی- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی محیط زیست یازدهم ریاضی- سری 6' },
  ],
  401: [
    { id: 1, title: 'نمونه سوال امتحان نهایی محیط زیست یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی محیط زیست یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی محیط زیست یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی محیط زیست یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی محیط زیست یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی محیط زیست یازدهم انسانی - سری 6' },
  ],
  402: [
    { id: 1, title: 'نمونه سوال امتحان نهایی محیط زیست یازدهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی محیط زیست یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی محیط زیست یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی محیط زیست یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی محیط زیست یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی محیط زیست یازدهم تجربی - سری 6' },
  ],
  403: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش یازدهم ریاضی- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش یازدهم ریاضی- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش یازدهم ریاضی- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش یازدهم ریاضی- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش یازدهم ریاضی- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش یازدهم ریاضی- سری6' },
  ],
  404: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش یازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش یازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش یازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش یازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش یازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش یازدهم انسانی - سری6' },
  ],
  405: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش یازدهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش یازدهم تجربی - سری6' },
  ],
  406: [
    { id: 1, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی مرداد 1403' },
    { id: 8, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی دی 1403' },
    { id: 9, title: 'امتحان نهایی سلامت و بهداشت دوازدهم ریاضی خرداد 1404' },
  ],
  407: [
    { id: 1, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی خرداد 1404' },
    { id: 8, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی دی 1403' },
    { id: 9, title: 'امتحان نهایی سلامت و بهداشت دوازدهم انسانی مرداد 1403' },
  ],
  408: [
    { id: 1, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی خرداد 1401' },
    { id: 2, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی خرداد 1402' },
    { id: 3, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی دی ماه 1401' },
    { id: 4, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی دی ماه 1402' },
    { id: 5, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی شهریور 1401' },
    { id: 6, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی شهریور 1402' },
    { id: 7, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی خرداد 1404' },
    { id: 8, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی دی 1403' },
    { id: 9, title: 'امتحان نهایی سلامت و بهداشت دوازدهم تجربی مرداد 1403' },
  ],
  412: [
    { id: 1, title: 'نمونه سوال امتحانی آموزش قرآن اول ابتدایی -سری1' },
    { id: 2, title: 'نمونه سوال امتحانی آموزش قرآن اول ابتدایی -سری2' },
    { id: 3, title: 'نمونه سوال امتحانی آموزش قرآن اول ابتدایی -سری3' },
    { id: 4, title: 'نمونه سوال امتحانی آموزش قرآن اول ابتدایی -سری4' },
    { id: 5, title: 'نمونه سوال امتحانی آموزش قرآن اول ابتدایی -سری5' },
    { id: 6, title: 'نمونه سوال امتحانی آموزش قرآن اول ابتدایی -سری6' },
  ],
  413: [
    { id: 1, title: 'نمونه سوال امتحانی ریاضی اول- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی ریاضی اول- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی ریاضی اول- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی ریاضی اول- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی اول- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی اول- سری 6' },
  ],
  414: [
    { id: 1, title: 'نمونه سوال امتحانی علوم اول- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی علوم اول- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی علوم اول- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی علوم اول- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم اول- سری 5' },
    { id: 6, title: 'نمونه سوالات امتحانی علوم اول-سری 6' },
  ],
  415: [
    { id: 1, title: 'نمونه سوال امتحانی فارسی اول- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فارسی اول- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فارسی اول- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فارسی اول- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فارسی اول- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فارسی اول- سری 6' },
  ],
  416: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش اول ابتدایی -سری1' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش اول ابتدایی -سری2' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش اول ابتدایی -سری3' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش اول ابتدایی -سری4' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش اول ابتدایی -سری5' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش اول ابتدایی -سری6' },
  ],
  417: [
    { id: 1, title: 'نمونه سوال آموزش قرآن دوم ابتدایی - سری1' },
    { id: 2, title: 'نمونه سوال آموزش قرآن دوم ابتدایی - سری3' },
    { id: 3, title: 'نمونه سوال آموزش قرآن دوم ابتدایی - سری4' },
    { id: 4, title: 'نمونه سوال آموزش قرآن دوم ابتدایی - سری5' },
    { id: 5, title: 'نمونه سوال آموزش قرآن دوم ابتدایی - سری6' },
  ],
  418: [
    { id: 1, title: 'نمونه سوال امتحانی ریاضی دوم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی ریاضی دوم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی ریاضی دوم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی ریاضی دوم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی دوم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی دوم- سری 6' },
  ],
  419: [
    { id: 1, title: 'نمونه سوال امتحانی علوم دوم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی علوم دوم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی علوم دوم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی علوم دوم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم دوم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی علوم دوم- سری 6' },
  ],
  420: [
    { id: 1, title: 'نمونه سوال امتحانی فارسی دوم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فارسی دوم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فارسی دوم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فارسی دوم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فارسی دوم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فارسی دوم- سری 6' },
  ],
  421: [
    { id: 1, title: 'نمونه سوال امتحان نگارش دوم ابتدایی - سری1' },
    { id: 2, title: 'نمونه سوال امتحان نگارش دوم ابتدایی - سری2' },
    { id: 3, title: 'نمونه سوال امتحان نگارش دوم ابتدایی - سری3' },
    { id: 4, title: 'نمونه سوال امتحان نگارش دوم ابتدایی - سری4' },
    { id: 5, title: 'نمونه سوال امتحان نگارش دوم ابتدایی - سری5' },
    { id: 6, title: 'نمونه سوال امتحان نگارش دوم ابتدایی - سری6' },
  ],
  422: [
    { id: 1, title: 'نمونه سوال امتحان هدیه های آسمان دوم ابتدایی - سری1' },
    { id: 2, title: 'نمونه سوال امتحان هدیه های آسمان دوم ابتدایی - سری2' },
    { id: 3, title: 'نمونه سوال امتحان هدیه های آسمان دوم ابتدایی - سری3' },
    { id: 4, title: 'نمونه سوال امتحان هدیه های آسمان دوم ابتدایی - سری4' },
    { id: 5, title: 'نمونه سوال امتحان هدیه های آسمان دوم ابتدایی - سری5' },
    { id: 6, title: 'نمونه سوال امتحان هدیه های آسمان دوم ابتدایی - سری6' },
  ],
  423: [
    { id: 1, title: 'نمونه سوال امتحان آموزش قران سوم ابتدایی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان آموزش قران سوم ابتدایی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان آموزش قران سوم ابتدایی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان آموزش قران سوم ابتدایی - سری 5' },
    { id: 5, title: 'نمونه سوال امتحان آموزش قران سوم ابتدایی - سری 6' },
    { id: 6, title: 'نمونه سوال امتحان آموزش قران سوم ابتدایی - سری4' },
  ],
  424: [
    { id: 1, title: 'نمونه سوال امتحانی ریاضی سوم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی ریاضی سوم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی ریاضی سوم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی ریاضی سوم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی سوم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی سوم- سری 6' },
  ],
  425: [
    { id: 1, title: 'نمونه سوال امتحانی علوم سوم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی علوم سوم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی علوم سوم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی علوم سوم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم سوم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی علوم سوم- سری 6' },
  ],
  426: [
    { id: 1, title: 'نمونه سوال امتحانی فارسی سوم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فارسی سوم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فارسی سوم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فارسی سوم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فارسی سوم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فارسی سوم- سری 6' },
  ],
  427: [
    { id: 1, title: 'نمونه سوال امتحانی مطالعات اجتماعی سوم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی مطالعات اجتماعی سوم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی مطالعات اجتماعی سوم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی مطالعات اجتماعی سوم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی مطالعات اجتماعی سوم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی مطالعات اجتماعی سوم- سری 6' },
  ],
  428: [
    { id: 1, title: 'نمونه سوال امتحان نگارش سوم ابتدایی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان نگارش سوم ابتدایی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان نگارش سوم ابتدایی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان نگارش سوم ابتدایی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان نگارش سوم ابتدایی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحان نگارش سوم ابتدایی - سری 6' },
  ],
  429: [
    { id: 1, title: 'نمونه سوال امتحان هدیه های آسمانی سوم ابتدایی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان هدیه های آسمانی سوم ابتدایی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان هدیه های آسمانی سوم ابتدایی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان هدیه های آسمانی سوم ابتدایی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان هدیه های آسمانی سوم ابتدایی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحان هدیه های آسمانی سوم ابتدایی - سری 6' },
  ],
  430: [
    { id: 1, title: 'نمونه سوال امتحانی آموزش قرآن چهارم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی آموزش قرآن چهارم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی آموزش قرآن چهارم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی آموزش قرآن چهارم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی آموزش قرآن چهارم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی آموزش قرآن چهارم- سری 6' },
  ],
  431: [
    { id: 1, title: 'نمونه سوال امتحانی ریاضی چهارم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی ریاضی چهارم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی ریاضی چهارم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی ریاضی چهارم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی چهارم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی چهارم- سری 6' },
  ],
  432: [
    { id: 1, title: 'نمونه سوال امتحانی علوم چهارم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی علوم چهارم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی علوم چهارم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی علوم چهارم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم چهارم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی علوم چهارم- سری 6' },
  ],
  433: [
    { id: 1, title: 'نمونه سوال امتحانی فارسی چهارم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فارسی چهارم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فارسی چهارم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فارسی چهارم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فارسی چهارم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فارسی چهارم- سری 6' },
  ],
  434: [
    { id: 1, title: 'نمونه سوال امتحانی مطالعات اجتماعی چهارم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی مطالعات اجتماعی چهارم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی مطالعات اجتماعی چهارم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی مطالعات اجتماعی چهارم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی مطالعات اجتماعی چهارم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی مطالعات اجتماعی چهارم- سری 6' },
  ],
  435: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش چهارم - سری 2' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش چهارم - سری 5' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش چهارم - سری 6' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش چهارم- سری 1' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش چهارم- سری 3.' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش چهارم- سری4 .' },
  ],
  436: [
    { id: 1, title: 'نمونه سوال امتحانی هدیه های آسمان چهارم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی هدیه های آسمان چهارم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی هدیه های آسمان چهارم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی هدیه های آسمان چهارم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی هدیه های آسمان چهارم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی هدیه های آسمان چهارم- سری 6' },
  ],
  437: [
    { id: 1, title: 'نمونه سوال امتحان آموزش قرآن پنجم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان آموزش قرآن پنجم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان آموزش قرآن پنجم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان آموزش قرآن پنجم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان آموزش قرآن پنجم - سری 5' },
    { id: 6, title: 'نمونه سوال امتحان آموزش قرآن پنجم - سری 6' },
  ],
  438: [
    { id: 1, title: 'نمونه سوال امتحانی ریاضی پنجم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی ریاضی پنجم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی ریاضی پنجم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی ریاضی پنجم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی پنجم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی پنجم- سری 6' },
  ],
  439: [
    { id: 1, title: 'نمونه سوال امتحانی علوم پنجم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی علوم پنجم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی علوم پنجم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی علوم پنجم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم پنجم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی علوم پنجم- سری 6' },
  ],
  440: [
    { id: 1, title: 'نمونه سوال امتحانی فارسی پنجم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فارسی پنجم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فارسی پنجم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فارسی پنجم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فارسی پنجم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فارسی پنجم- سری 6' },
  ],
  441: [
    { id: 1, title: 'نمونه سوال امتحانی مطالعات اجتماعی پنجم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی مطالعات اجتماعی پنجم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی مطالعات اجتماعی پنجم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی مطالعات اجتماعی پنجم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی مطالعات اجتماعی پنجم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی مطالعات اجتماعی پنجم- سری 6' },
  ],
  442: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش پنجم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش پنجم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش پنجم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش پنجم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش پنجم - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش پنجم - سری 6' },
  ],
  443: [
    { id: 1, title: 'نمونه سوال امتحانی هدیه های آسمان پنجم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی هدیه های آسمان پنجم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی هدیه های آسمان پنجم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی هدیه های آسمان پنجم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی هدیه های آسمان پنجم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی هدیه های آسمان پنجم- سری 6' },
  ],
  444: [
    { id: 1, title: 'نمونه سوال آموزش قرآن ششم - سری 1' },
    { id: 2, title: 'نمونه سوال آموزش قرآن ششم - سری 2' },
    { id: 3, title: 'نمونه سوال آموزش قرآن ششم - سری 3' },
    { id: 4, title: 'نمونه سوال آموزش قرآن ششم - سری 4' },
    { id: 5, title: 'نمونه سوال آموزش قرآن ششم - سری 5' },
    { id: 6, title: 'نمونه سوال آموزش قرآن ششم - سری 6' },
  ],
  445: [
    { id: 1, title: 'نمونه سوال امتحانی تفکر و پژوهش ششم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی تفکر و پژوهش ششم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی تفکر و پژوهش ششم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی تفکر و پژوهش ششم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی تفکر و پژوهش ششم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی تفکر و پژوهش ششم- سری 6' },
  ],
  446: [
    { id: 1, title: 'نمونه سوال امتحانی ریاضی ششم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی ریاضی ششم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی ریاضی ششم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی ریاضی ششم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی ششم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی ششم- سری 6' },
  ],
  447: [
    { id: 1, title: 'نمونه سوال امتحانی علوم ششم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی علوم ششم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی علوم ششم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی علوم ششم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم ششم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی علوم ششم- سری 6' },
  ],
  448: [
    { id: 1, title: 'نمونه سوال امتحانی فارسی ششم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فارسی ششم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فارسی ششم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فارسی ششم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فارسی ششم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فارسی ششم- سری 6' },
  ],
  449: [
    { id: 1, title: 'نمونه سوال امتحانی مطالعات اجتماعی ششم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی مطالعات اجتماعی ششم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی مطالعات اجتماعی ششم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی مطالعات اجتماعی ششم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی مطالعات اجتماعی ششم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی مطالعات اجتماعی ششم- سری 6' },
  ],
  450: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش ششم- سری 1.' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش ششم- سری 3.' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش ششم- سری 4.' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش ششم- سری 5.' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش ششم- سری 6.' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش ششم- سری2.' },
  ],
  451: [
    { id: 1, title: 'نمونه سوال امتحانی هدیه های آسمان ششم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی هدیه های آسمان ششم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی هدیه های آسمان ششم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی هدیه های آسمان ششم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی هدیه های آسمان ششم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی هدیه های آسمان ششم- سری 6' },
  ],
  452: [
    { id: 1, title: 'نمونه سوال امتحان کار و فناوری ششم ابتدایی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان کار و فناوری ششم ابتدایی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان کار و فناوری ششم ابتدایی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان کار و فناوری ششم ابتدایی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان کار و فناوری ششم ابتدایی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحان کار و فناوری ششم ابتدایی - سری 6' },
  ],
  453: [
    { id: 1, title: 'نمونه سوال امتحانی آموزش قرآن هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی آموزش قرآن هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی آموزش قرآن هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی آموزش قرآن هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی آموزش قرآن هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی آموزش قرآن هفتم- سری 6' },
  ],
  454: [
    { id: 1, title: 'نمونه سوال امتحانی انگلیسی هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی انگلیسی هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی انگلیسی هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی انگلیسی هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی انگلیسی هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی انگلیسی هفتم- سری 6' },
  ],
  455: [
    { id: 1, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هفتم- سری 6' },
  ],
  456: [
    { id: 1, title: 'نمونه سوال امتحانی ریاضی هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی ریاضی هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی ریاضی هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی ریاضی هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی هفتم- سری 6' },
  ],
  457: [
    { id: 1, title: 'نمونه سوال امتحانی عربی هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی عربی هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی عربی هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی عربی هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی عربی هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی عربی هفتم- سری 6' },
  ],
  458: [
    { id: 1, title: 'نمونه سوال امتحانی علوم هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی علوم هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی علوم هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی علوم هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی علوم هفتم- سری 6' },
  ],
  459: [
    { id: 1, title: 'نمونه سوال امتحانی فارسی هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فارسی هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فارسی هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فارسی هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فارسی هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فارسی هفتم- سری 6' },
  ],
  460: [
    { id: 1, title: 'نمونه سوال امتحانی مطالعات اجتماعی هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی مطالعات اجتماعی هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی مطالعات اجتماعی هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی مطالعات اجتماعی هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی مطالعات اجتماعی هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی مطالعات اجتماعی هفتم- سری 6' },
  ],
  461: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش هفتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش هفتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش هفتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش هفتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش هفتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش هفتم- سری 6' },
  ],
  462: [
    { id: 1, title: 'نمونه سوال امتحانی پیام های آسمان هفتم- سری 6' },
    { id: 2, title: 'نمونه سوال امتحانی پیام های آسمان هفتم- سری 1' },
    { id: 3, title: 'نمونه سوال امتحانی پیام های آسمان هفتم- سری 2' },
    { id: 4, title: 'نمونه سوال امتحانی پیام های آسمان هفتم- سری 3' },
    { id: 5, title: 'نمونه سوال امتحانی پیام های آسمان هفتم- سری 4' },
    { id: 6, title: 'نمونه سوال امتحانی پیام های آسمان هفتم- سری 5' },
  ],
  463: [
    { id: 1, title: 'نمونه سوال امتحانی آموزش قرآن هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی آموزش قرآن هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی آموزش قرآن هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی آموزش قرآن هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی آموزش قرآن هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی آموزش قرآن هشتم- سری 6' },
  ],
  464: [
    { id: 1, title: 'نمونه سوال امتحانی انگلیسی هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی انگلیسی هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی انگلیسی هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی انگلیسی هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی انگلیسی هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی انگلیسی هشتم- سری 6' },
  ],
  465: [
    { id: 1, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی تفکر و سبک زندگی هشتم- سری 6' },
  ],
  466: [
    { id: 1, title: 'نمونه سوال امتحانی ریاضی هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی ریاضی هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی ریاضی هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی ریاضی هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی ریاضی هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی ریاضی هشتم- سری 6' },
  ],
  467: [
    { id: 1, title: 'نمونه سوال امتحانی عربی هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی عربی هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی عربی هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی عربی هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی عربی هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی عربی هشتم- سری 6' },
  ],
  468: [
    { id: 1, title: 'نمونه سوال امتحانی علوم هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی علوم هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی علوم هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی علوم هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی علوم هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی علوم هشتم- سری 6' },
  ],
  469: [
    { id: 1, title: 'نمونه سوال امتحانی فارسی هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی فارسی هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی فارسی هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی فارسی هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی فارسی هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی فارسی هشتم- سری 6' },
  ],
  470: [
    { id: 1, title: 'نمونه سوال امتحانی مطالعات اجتماعی هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی مطالعات اجتماعی هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی مطالعات اجتماعی هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی مطالعات اجتماعی هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی مطالعات اجتماعی هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی مطالعات اجتماعی هشتم- سری 6' },
  ],
  471: [
    { id: 1, title: 'نمونه سوال امتحانی نگارش هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی نگارش هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی نگارش هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی نگارش هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی نگارش هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی نگارش هشتم- سری 6' },
  ],
  472: [
    { id: 1, title: 'نمونه سوال امتحانی پیام های آسمان هشتم- سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی پیام های آسمان هشتم- سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی پیام های آسمان هشتم- سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی پیام های آسمان هشتم- سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی پیام های آسمان هشتم- سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی پیام های آسمان هشتم- سری 6' },
  ],
  473: [
    { id: 1, title: 'نمونه سوال امتحانی آمادگی دفاعی نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی آمادگی دفاعی نهم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی آمادگی دفاعی نهم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی آمادگی دفاعی نهم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی آمادگی دفاعی نهم - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی آمادگی دفاعی نهم - سری 6' },
  ],
  474: [
    { id: 1, title: 'نمونه سوال امتحانی قرآن پایه نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی قرآن پایه نهم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی قرآن پایه نهم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی قرآن پایه نهم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی قرآن پایه نهم - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی قرآن پایه نهم - سری 6' },
  ],
  475: [
    { id: 1, title: 'نمونه سوال امتحان ریاضی نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان ریاضی نهم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان ریاضی نهم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان ریاضی نهم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان ریاضی نهم - سری 5' },
    { id: 6, title: 'نمونه سوال امتحان ریاضی نهم - سری 6' },
  ],
  476: [
    { id: 1, title: 'نمونه سوال زبان انگلیسی نهم - سری 1' },
    { id: 2, title: 'نمونه سوال زبان انگلیسی نهم - سری 2' },
    { id: 3, title: 'نمونه سوال زبان انگلیسی نهم - سری 3' },
    { id: 4, title: 'نمونه سوال زبان انگلیسی نهم - سری 4' },
    { id: 5, title: 'نمونه سوال زبان انگلیسی نهم - سری 5' },
    { id: 6, title: 'نمونه سوال زبان انگلیسی نهم - سری 6' },
  ],
  477: [
    { id: 1, title: 'نمونه سوال امتحان عربی نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان عربی نهم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان عربی نهم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان عربی نهم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان عربی نهم - سری 5' },
    { id: 6, title: 'نمونه سوال امتحان عربی نهم - سری 6' },
  ],
  478: [
    { id: 1, title: 'نمونه سوال امتحان عربی نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان عربی نهم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان عربی نهم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان عربی نهم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان عربی نهم - سری 5' },
    { id: 6, title: 'نمونه سوال امتحان عربی نهم - سری 6' },
  ],
  479: [
    { id: 1, title: 'نمونه سوال امتحان فارسی نهم - سری1' },
    { id: 2, title: 'نمونه سوال امتحان فارسی نهم - سری2' },
    { id: 3, title: 'نمونه سوال امتحان فارسی نهم - سری3' },
    { id: 4, title: 'نمونه سوال امتحان فارسی نهم - سری5' },
    { id: 5, title: 'نمونه سوال امتحان فارسی نهم - سری6' },
    { id: 6, title: 'نمونه سوال امتحان نهایی فارسی نهم - سری 4' },
  ],
  480: [
    { id: 1, title: 'نمونه سوال امتحان مطالعات اجتماعی نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان مطالعات اجتماعی نهم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحان مطالعات اجتماعی نهم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحان مطالعات اجتماعی نهم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحان مطالعات اجتماعی نهم - سری 6' },
    { id: 6, title: 'نمونه سوال امتحان مطالعات اجتماعی نهم - سری5' },
  ],
  481: [
    { id: 1, title: 'نمونه سوال امتحان نگارش فارسی نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحان نگارش فارسی نهم - سری 2(1)' },
    { id: 3, title: 'نمونه سوال امتحان نگارش فارسی نهم - سری 2' },
    { id: 4, title: 'نمونه سوال امتحان نگارش فارسی نهم - سری 3(1)' },
    { id: 5, title: 'نمونه سوال امتحان نگارش فارسی نهم - سری 3' },
    { id: 6, title: 'نمونه سوال امتحان نگارش فارسی نهم - سری 4' },
    { id: 7, title: 'نمونه سوال امتحان نگارش فارسی نهم - سری 5' },
    { id: 8, title: 'نمونه سوال امتحان نگارش فارسی نهم - سری 6' },
  ],
  482: [
    { id: 1, title: 'نمونه سوال امتحانی پیام های آسمان نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی پیام های آسمان نهم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی پیام های آسمان نهم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی پیام های آسمان نهم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی پیام های آسمان نهم - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی پیام های آسمان نهم - سری 6' },
  ],
  483: [{ id: 1, title: 'نمونه سوال امتحانی فرهنگ و هنر نهم - سری 1' }],
  484: [
    { id: 1, title: 'نمونه سوال امتحانی کار و فناوری نهم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی کار و فناوری نهم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی کار و فناوری نهم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی کار و فناوری نهم - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی کار و فناوری نهم - سری 5' },
  ],
  485: [{ id: 1, title: 'نمونه سوال امتحانی فرهنگ و هنر هشتم - سری 1' }],
  486: [
    { id: 1, title: 'نمونه سوال امتحانی کار و فناوری هشتم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی کار و فناوری هشتم - سری 2' },
  ],
  487: [
    { id: 1, title: 'نمونه سوال امتحانی تربیت دینی هفتم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی تربیت دینی هفتم - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی تربیت دینی هفتم - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی تربیت دینی هفتم - سری 4' },
  ],
  488: [{ id: 1, title: 'نمونه سوال امتحانی فرهنگ و هنر هفتم - سری 1' }],
  489: [
    { id: 1, title: 'نمونه سوال امتحانی کار و فناوری هفتم - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی کار و فناوری هفتم - سری 2' },
  ],
  490: [
    { id: 1, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم ریاضی- سری 6' },
  ],
  491: [
    { id: 1, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم ریاضی - سری 6' },
  ],
  492: [
    { id: 1, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال آزمایشگاه علوم تجربی دهم تجربی - سری 6' },
  ],
  493: [
    { id: 1, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم تجربی - سری 6' },
  ],
  494: [
    { id: 1, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال کارگاه کارآفرینی و تولید دهم انسانی - سری 6' },
  ],
  495: [
    { id: 1, title: 'نمونه سوال نگارش دهم انسانی نوبت دوم - سری 1' },
    { id: 2, title: 'نمونه سوال نگارش دهم انسانی نوبت دوم - سری 2' },
    { id: 3, title: 'نمونه سوال نگارش دهم انسانی نوبت دوم - سری 3' },
    { id: 4, title: 'نمونه سوال نگارش دهم انسانی نوبت دوم - سری 4' },
    { id: 5, title: 'نمونه سوال نگارش دهم انسانی نوبت دوم - سری 5' },
    { id: 6, title: 'نمونه سوال نگارش دهم انسانی نوبت دوم - سری 6' },
  ],
  496: [
    { id: 1, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم ریاضی - سری 6' },
  ],
  497: [
    { id: 1, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم تجربی  - سری 1' },
    { id: 2, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوال آزمایشگاه علوم تجربی یازدهم تجربی - سری 6' },
  ],
  498: [
    { id: 1, title: 'نمونه سوال امتحانی تحلیل فرهنگی دوازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال امتحانی تحلیل فرهنگی دوازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال امتحانی تحلیل فرهنگی دوازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال امتحانی تحلیل فرهنگی دوازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال امتحانی تحلیل فرهنگی دوازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال امتحانی تحلیل فرهنگی دوازدهم انسانی - سری 6' },
  ],
  499: [
    { id: 1, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم انسانی - سری 6' },
  ],
  500: [
    { id: 1, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم تجربی - سری 1' },
    { id: 2, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم تجربی - سری 2' },
    { id: 3, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم تجربی - سری 3' },
    { id: 4, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم تجربی - سری 4' },
    { id: 5, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم تجربی - سری 5' },
    { id: 6, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم تجربی - سری 6' },
  ],
  501: [
    { id: 1, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوالات مدیریت خانواده و سبک زندگی دوازدهم ریاضی - سری 6' },
  ],
  502: [
    { id: 1, title: 'نمونه سوال نگارش دوازدهم انسانی - سری 1' },
    { id: 2, title: 'نمونه سوال نگارش دوازدهم انسانی - سری 2' },
    { id: 3, title: 'نمونه سوال نگارش دوازدهم انسانی - سری 3' },
    { id: 4, title: 'نمونه سوال نگارش دوازدهم انسانی - سری 4' },
    { id: 5, title: 'نمونه سوال نگارش دوازدهم انسانی - سری 5' },
    { id: 6, title: 'نمونه سوال نگارش دوازدهم انسانی - سری 6' },
  ],
  503: [
    { id: 1, title: 'نمونه سوال نگارش دوازدهم تجربی- سری 1' },
    { id: 2, title: 'نمونه سوال نگارش دوازدهم تجربی- سری 2' },
    { id: 3, title: 'نمونه سوال نگارش دوازدهم تجربی- سری 3' },
    { id: 4, title: 'نمونه سوال نگارش دوازدهم تجربی- سری 4' },
    { id: 5, title: 'نمونه سوال نگارش دوازدهم تجربی- سری 5' },
    { id: 6, title: 'نمونه سوال نگارش دوازدهم تجربی- سری 6' },
  ],
  504: [
    { id: 1, title: 'نمونه سوال نگارش دوازدهم  ریاضی - سری 1' },
    { id: 2, title: 'نمونه سوال نگارش دوازدهم  ریاضی - سری 2' },
    { id: 3, title: 'نمونه سوال نگارش دوازدهم  ریاضی - سری 3' },
    { id: 4, title: 'نمونه سوال نگارش دوازدهم  ریاضی - سری 4' },
    { id: 5, title: 'نمونه سوال نگارش دوازدهم  ریاضی - سری 5' },
    { id: 6, title: 'نمونه سوال نگارش دوازدهم  ریاضی - سری 6' },
  ],
};
